import { Grid3X3, CircleDot, Box, Square } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";

const backgroundOptions = [
  {
    name: "Plain",
    background_key: "plain",
    icon: <Box className="h-5 w-5" />,
  },
  {
    name: "Grid",
    background_key: "grid",
    icon: <Grid3X3 className="h-5 w-5" />,
  },
  {
    name: "Dots",
    background_key: "dots",
    icon: <CircleDot className="h-5 w-5" />,
  },
];

export function BackgroundToggle() {
  const [backgroundType, setBackgroundType] = useState("plain");

  // Initialize from localStorage on component mount
  useEffect(() => {
    const savedBackground = localStorage.getItem("background_type") || "plain";
    setBackgroundType(savedBackground);
  }, []);

  // Get the current icon based on the selected background
  const currentIcon = backgroundOptions.find(item => item.background_key === backgroundType)?.icon ||
    <Square className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all" />;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="muted-ghost" size="icon-md">
          {currentIcon}
          <span className="sr-only">Toggle background style</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Background</DropdownMenuLabel>
        {backgroundOptions.map((item) => (
          <DropdownMenuItem
            key={item.background_key}
            onClick={() => {
              localStorage.setItem("background_type", item.background_key);
              setBackgroundType(item.background_key);
              window.dispatchEvent(new Event("storage"));
            }}
          >
            {item.icon}
            {item.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}